import React, {Component} from "react";
import AnnotationsExpandableList from "./AnnotationsExpandableList";
import {connect} from "react-redux";
import {AnnotationsConstants, defaultIHCAdvancedFields, Loader} from "../../../utils/const";
import {clearSelectFeatures, locateAnnotationOnMap, setActiveAllSelectInteractions} from "../utils/map_utils";
import {updateActiveAnnoDrawer} from "../../../redux_actions/gamma.state.action";
import {
	getIHCResultComponent,
	getIHCResultFeatures,
	isAddOperation,
	OPERATIONS,
	prepareStatus,
	runIHCAnalysis,
	saveIHCCounts,
} from "../utils/ihc_app_utils";
import {
	Button, ButtonGroup, Checkbox,
	CircularProgress, Grid,
	IconButton, MenuItem,
	Paper, Popper, Select,
	Stack, TextField,
	ToggleButton,
	ToggleButtonGroup,
	Tooltip, Typography, Autocomplete, Divider, CssBaseline, ThemeProvider
} from "@mui/material";
import {
	AddCircleTwoTone,
	DeleteTwoTone,
	EditTwoTone,
	RemoveCircleTwoTone,
	SaveTwoTone,
	VisibilityOff
} from "@mui/icons-material";
import {_addAnnotation, fullStitchSlide, initSlide, updateAnnotation} from "../../../redux_actions/maps.state.action";
import _ from 'lodash';
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import {getEyeCheckbox, LoadingText} from "../components/components";
import {blue, red} from "../utils/annotations_app_utils";
import Polygon from "ol/geom/Polygon";
import {unByKey} from "ol/Observable";
import RefreshIcon from "@mui/icons-material/Refresh";
import {isCloud, isNull, notNull} from "../../../utils/utils";
import {annotationsApp, ihcApp} from "../app_maker";
import {notifyInfo, notifySuccess, notifyWarning} from "../utils/display.notification";
import CloseIcon from "@mui/icons-material/Close";
import SaveAsTwoToneIcon from '@mui/icons-material/SaveAsTwoTone';
import AutoAwesomeMotionTwoToneIcon from '@mui/icons-material/AutoAwesomeMotionTwoTone';
import {post} from "../../../helper/request";
import CreateChip from "../components/CreateButton";
import {IHCAnalysisProfile} from "../../../utils/api";
import {error_manager} from "../../../helper/error_manager";
import {defaultTheme, morphleTheme1} from "../themes";
import {boundingExtent} from "ol/extent";

class IHCApp extends Component {

	constructor(props) {
		super(props);

		this.ref = React.createRef();

		this.drawer = ihcApp.drawer;
		this.state = {
			operation: null,
			drawedAnnotations: [],
			advancedIHCPanelAnnotationId: null,
			selectedProfileID: null,
			ihcProfiles: [],
			IHCAdvancedFields: defaultIHCAdvancedFields,
			inputsDirty: false,
		}
		this.pollingInterval = null;
	}

	componentDidMount() {
		this.props.dispatch(updateActiveAnnoDrawer(this.drawer));
		if (notNull(this.props.slidemap)) {
			this.clickEventKey = this.props.slidemap.on('click', e => this.add(e.coordinate));
			this.draw();
		}
		IHCAnalysisProfile("GET").then(data => {
			this.setState({ihcProfiles: data})
			data.find(profile => profile.is_default) && this.setState({selectedProfileID: data.find(profile => profile.is_default).id})
		});
		this.startIHCPolling();
	}

	componentWillUnmount() {
		this.props.dispatch(updateActiveAnnoDrawer(annotationsApp.drawer));
		unByKey(this.clickEventKey);
		setActiveAllSelectInteractions(this.props.slidemap, true);
		this.stopIHCPolling();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		setActiveAllSelectInteractions(this.props.slidemap, !isAddOperation(this.state.operation));
		if (isNull(prevProps.slide) && notNull(this.props.slide)) {
			this.clickEventKey = this.props.slidemap.on('click', e => this.add(e.coordinate));
			this.draw();
		}

		if (prevState.selectedProfileID !== this.state.selectedProfileID) {
			const { selectedProfileID, ihcProfiles, IHCAdvancedFields } = this.state;
			if (selectedProfileID) {
				const selectedProfile = ihcProfiles.find(profile => profile.id === selectedProfileID);
				if (selectedProfile) {
					const updatedFields = IHCAdvancedFields.map(param => {
						const { key } = param;
						return {
							...param,
							value: selectedProfile.config[key] || param.value
						};
					});
					this.setState({ IHCAdvancedFields: updatedFields, inputsDirty: false });
				}
			}
		}
	}

	startIHCPolling() {
		this.pollingInterval = setInterval(this.fetchIHCStatus, 2000);
	}

	stopIHCPolling() {
		if (this.pollingInterval) {
			clearInterval(this.pollingInterval);
		}
	}

	fetchIHCStatus = async (forceRun=false) => {
		try {
			if (!this.props.slide) return;
			if (!this.props.annotationState) return;

			const annotations = this.props.annotationState.annotations.filter(annotation => annotation.anno_drawer === this.drawer);
			let sendRequest = false;
			const payload = annotations.map(annotation => ({
				id: annotation.id,
				ihc_analysis_status: annotation.ihc_analysis?.status || "na"
			}));

			const payloadObject = payload.reduce((acc, { id, ihc_analysis_status }) => {
				acc[id] = ihc_analysis_status;
				if (ihc_analysis_status === "running") {
					sendRequest = true;
				}
				return acc;
			}, {});

			if (!sendRequest && !forceRun) return;

			const newData = await post(`/api/ihc/status/${this.props.slide.id}/`, payloadObject);
			newData.forEach(newAnnotationData => {
				const existingAnnotation = this.props.annotationState?.annotations.find(annotation => annotation.id === newAnnotationData.id);
				if (existingAnnotation) {
					const keys = Object.keys(newAnnotationData);
					const isChanged = keys.some(key => !_.isEqual(newAnnotationData[key], existingAnnotation[key]));
					if (isChanged) {
						this.props.dispatch(_addAnnotation(this.props.activeMapId, { ...existingAnnotation, ...newAnnotationData }));
					}
				}
			});
		} catch (error) {
			console.log("pollingerror", error)
		}
	}

	add = (coordinate) => {
		if (this.state.operation === OPERATIONS.ADD_POSITIVE || this.state.operation === OPERATIONS.ADD_NEGATIVE) {
			let intersectingAnnotation = this.state.drawedAnnotations.find(annotation =>
				annotation.feature.getGeometry().intersectsCoordinate(coordinate));
			if (!intersectingAnnotation) return;
			let [x, y] = coordinate;
			let size = 20;
			let coordinates = [[x, y - size], [x - size, y], [x, y + size], [x + size, y], [x - size, y], [x, y - size],
				[x, y + size], [x + size, y], [x, y - size]];
			let [to, color] = this.state.operation === OPERATIONS.ADD_POSITIVE ? ['pos', red] : ['neg', blue];
			let result = intersectingAnnotation.result[to];
			let id = `${intersectingAnnotation.id}${to}${Math.random() * 1e9}`
			let feature = new Feature({
				id, color, coordinates,
				geometry: new Polygon([coordinates]),
			});
			feature.setId(id);
			result.push(coordinates);
			this.source.addFeature(feature);
			this.setState({});
		}
	}

	edit = (feature) => {
		let featureId = feature.getId();
		let coordinates = feature.getProperties().coordinates;
		let annotationId = parseInt(featureId);
		let result = this.state.drawedAnnotations.find(annotation => annotation.id === annotationId).result;
		let isPos = featureId.includes('pos');
		let [from, to, color] = isPos ? ['pos', 'neg', blue] : ['neg', 'pos', red];
		let id = featureId.replace(from, to);
		this.source.removeFeature(feature);
		let newFeature = new Feature({
			id,
			color,
			coordinates,
			geometry: new Polygon([coordinates]),
		});
		newFeature.setId(id);
		result[from] = result[from].filter(polygon => polygon !== coordinates);
		result[to].push(coordinates);
		this.source.addFeature(newFeature);
	}

	delete = (feature) => {
		let featureId = feature.getId();
		let coordinates = feature.getProperties().coordinates;
		let annotationId = parseInt(featureId);
		let result = this.state.drawedAnnotations.find(annotation => annotation.id === annotationId).result;
		let isPos = featureId.includes('pos');
		let from = isPos ? 'pos' : 'neg';
		result[from] = result[from].filter(polygon => polygon !== coordinates);
		this.source.removeFeature(feature);
	}

	save = () => this.state.drawedAnnotations.forEach(annotation => saveIHCCounts(annotation));

	refreshAnnotation = (annotation) =>
		this.props.dispatch(updateAnnotation(this.props.activeMapId, {id: annotation.id}))

	refreshSlide = () => this.props.dispatch(initSlide(this.props.activeMapId, this.props.slide.id));

	refresh = (refreshSlide = false) => {
		((this.props.annotationState || {}).annotations || []).filter(annotation =>
			annotation.anno_drawer === this.drawer).forEach(annotation => this.refreshAnnotation(annotation));
		if (refreshSlide) {
			this.refreshSlide();
		}
	}

	prepare = () => this.props.dispatch(fullStitchSlide(this.props.activeMapId, this.props.slide.id));

	getAdvancedIHCParams = () => {
		const formData = {};

		this.state.IHCAdvancedFields.forEach(param => {
			const {key, type} = param;
			let value = null;

			switch (type) {
				case "input":
				case "choice":
				case "boolean":
					value = param.value;
					break;
				default:
					break;
			}
			if (notNull(value)) {
				formData[key] = value;
			}
		});
		return formData;
	}

	createProfile = (profileName) => {
		const params = this.getAdvancedIHCParams();
		IHCAnalysisProfile("ADD", {name: profileName, config: params}).then(() => {
			notifySuccess("IHCNotif", "Profile created successfully.")
			IHCAnalysisProfile("GET").then(data => this.setState({ihcProfiles: data}, () => {
				this.setState({selectedProfileID: data.find(profile => profile.name === profileName).id})
			}));
		}).catch(err => {
			error_manager('', err)
		});
	}

	saveSettingsToProfile = () => {
		const params = this.getAdvancedIHCParams();
		if (notNull(this.state.selectedProfileID)) {
			IHCAnalysisProfile("UPDATE", {id: this.state.selectedProfileID, config: params}).then(() => {
				notifySuccess("IHCNotif", "Profile updated successfully.")
				IHCAnalysisProfile("GET").then(data => this.setState({ihcProfiles: data}))
			}).catch(err => {
				error_manager('', err)
			});
		}
	}

	deleteProfile = () => {
		if (notNull(this.state.selectedProfileID)) {
			IHCAnalysisProfile("DELETE", {id: this.state.selectedProfileID}).then(() => {
				notifySuccess("IHCNotif", "Profile deleted successfully.")
				IHCAnalysisProfile("GET").then(data => this.setState({ihcProfiles: data}, () => {
					this.setState({selectedProfileID: data[0].id})
				}));
			}).catch(err => {
				error_manager('', err)
			});
		}
	}

	setDefaultProfile = () => {
		if (notNull(this.state.selectedProfileID)) {
			IHCAnalysisProfile("SET_DEFAULT", {id: this.state.selectedProfileID}).then(() => {
				notifySuccess("IHCNotif", "Profile set as default.")
				IHCAnalysisProfile("GET").then(data => this.setState({ihcProfiles: data}));
			}).catch(err => {
				error_manager('', err)
			});
		}
	}

	advancedComponentTopBar = () => {

		const selectedProfile = this.state.ihcProfiles.find(profile => profile.id === this.state.selectedProfileID);
		const isDefault = selectedProfile?.is_default;


		return (<Stack direction="row" className={"full-width"} alignItems="center" justifyContent="space-between" paddingTop={1}>
			<Stack direction="row" alignItems="center" width={"65%"}>
				<ThemeProvider theme={defaultTheme}>
				<Autocomplete
					disablePortal
					size="small"
					sx={{flex: 1, backgroundColor: "#d8d8d8"}}
					options={this.state.ihcProfiles}
					value={this.state.ihcProfiles.find(profile => profile.id === this.state.selectedProfileID)}
					getOptionLabel={(option) => {
						if (option.is_default) {
							return option.name + " (default)"
						}
						return option.name
					}}
					onChange={(e, value) => this.setState({selectedProfileID: value ? value.id : null})}
					renderInput={(params) => <TextField {...params} label=""  placeholder={"select profile"}/>}
				/>
				</ThemeProvider>
				<ButtonGroup>
					<IconButton sx={{color: '#92ebaa'}} onClick={this.saveSettingsToProfile} disabled={isNull(this.state.selectedProfileID) || !this.state.inputsDirty}>
						<Tooltip title={"Save Settings to Profile"} placement={"top-start"}>
							<SaveAsTwoToneIcon/>
						</Tooltip>
					</IconButton>
					<IconButton sx={{color: '#fa8e8e'}} onClick={this.deleteProfile} disabled={isNull(this.state.selectedProfileID) || this.state.ihcProfiles.length <= 1}>
						<Tooltip title={"Delete Profile"} placement={"top-start"}>
							<DeleteTwoTone/>
						</Tooltip>
					</IconButton>
					<IconButton sx={{color: '#ffe294'}} onClick={this.setDefaultProfile} disabled={isNull(this.state.selectedProfileID) || isDefault}>
						<Tooltip title={"Set as Default Profile"} placement={"top-start"}>
							<AutoAwesomeMotionTwoToneIcon/>
						</Tooltip>
					</IconButton>
				</ButtonGroup>
			</Stack>
			<Stack direction="row" alignItems="center">
				<CreateChip onCreate={this.createProfile} label={"+ Add"}
							sx={{
								width: "80px",
								borderRadius: 1,
								margin: 0.25,
								borderStyle: "dashed",
								mx: 1.5,
							}}/>
			</Stack>
		</Stack>)
	}

	advancedIHCComponent = (annotations) => {
		if (isNull(this.state.advancedIHCPanelAnnotationId)) return null;

		const handleInputChange = (event) => {
			const { name, value, type, checked } = event.target;
			this.setState(prevState => ({
				IHCAdvancedFields: prevState.IHCAdvancedFields.map(param => {
					if (param.key === name) {
						return {
							...param,
							value: type === "checkbox" ? checked : value
						};
					}
					return param;
				}),
				inputsDirty: true
			}));
		};

		const inputField = (param) => {
			const {key, label, value, unit, type, options} = param;

			switch (type) {
				case "input":
					return (
						<React.Fragment>
							<Grid item xs={6} key={key}>{label}</Grid>
							<Grid item xs={4}>
								<TextField name={key} value={value} variant="outlined" type="number" onChange={handleInputChange}
										   sx={{
											   "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
												   display: "none",
											   },
											   "& input[type=number]": {
												   MozAppearance: "textfield",
											   },
										   }}/>
							</Grid>
							<Grid item xs={2}>{unit}</Grid>
						</React.Fragment>
					);
				case "choice":
					return (
						<React.Fragment>
							<Grid item xs={6}>{label}</Grid>
							<Grid item xs={4}>
								<Select name={key} value={value} variant="outlined" onChange={handleInputChange}>
									{options.map(option => (
										<MenuItem key={option} value={option}>{option}</MenuItem>
									))}
								</Select>
							</Grid>
							<Grid item xs={2}>{unit}</Grid>
						</React.Fragment>
					);
				case "boolean":
					return (
						<React.Fragment>
							<Grid item xs={6}>{label}</Grid>
							<Grid item xs={4}>
								<Checkbox name={key} color="secondary" checked={value} onChange={handleInputChange} sx={{p: 0}}/>
							</Grid>
							<Grid item xs={2}>{unit}</Grid>
						</React.Fragment>
					);
				case "header":
					return (header(label));
				default:
					return null;
			}
		};

		const header = (name) => <Grid item xs={12} py={0.5}><Typography variant="h6" color={"#dadada"}
																	   sx={{fontWeight: "bold"}}>{name}</Typography></Grid>

		return <Popper placement="right" open={notNull(this.state.advancedIHCPanelAnnotationId)}
					   anchorEl={this.ref.current?.parentElement}>
			<Paper sx={{
				height: "calc( 100vh - 48px )",
				width: "500px",
				marginTop: "48px",
				borderRadius: 0,
				backgroundColor: "#200445",
				color: "#b6b4b4",
				p: 1
			}}>
				<Stack className="full-parent" justifyContent={"space-between"} spacing={1}>
					<Grid container>
						<Grid item xs={10}>
							<Typography variant="h6" color={"#ffffff"} sx={{fontWeight: "bold"}}>Advanced Configuration</Typography>
						</Grid>
						<Grid item xs={1} />
						<Grid item xs={1}>
							<IconButton type="primary" color="error" onClick={() => this.setState({advancedIHCPanelAnnotationId: null})}>
								<CloseIcon sx={{color: "red"}}/>
							</IconButton>
						</Grid>
					</Grid>
					<Grid container flex={1} sx={{overflowY: "scroll"}}>
						{this.state.IHCAdvancedFields.map(param => inputField(param))}
					</Grid>
					<Stack>
						<Divider />
						{this.advancedComponentTopBar()}
						<Grid container>
							<Grid item xs={12} sx={{display: "flex", justifyContent: "center", marginTop: 1}}>
								<Button variant="outlined" fullWidth color={"secondary"}
										onClick={() => {this.run(annotations)}}
								>
									Run
								</Button>
							</Grid>
						</Grid>
					</Stack>

				</Stack>
			</Paper>
		</Popper>
	}

	run = (annotations) => {
		const selectedAnnotations = this.props.annotationState.selectedAnnotations;
		if (selectedAnnotations.length === 0) {
			notifyWarning("IHCNotif", "Please select at least one annotation to run IHC analysis.")
			return;
		}

		const notAllowedAnnotations = annotations.filter(annotation => selectedAnnotations.includes(annotation.id)).filter(annotation => annotation.ihc_analysis?.status === 'running');
		if (notAllowedAnnotations.length > 0) {
			notifyWarning("IHCNotif", "Some annotations are already running IHC analysis, wait for them to complete.")
			return;
		}

		const notAllowedAnnotations_size = annotations.filter(annotation => selectedAnnotations.includes(annotation.id)).filter(annotation => annotation.area > 171000);
		if (notAllowedAnnotations_size.length > 0) {
			notifyWarning("IHCNotifLarge", "Some annotations are large in size to process, Please draw annotations of size 0.170 sq.mm or lesser. Other annotations are forwarded for processing.")
			
		}
		
		const selectedAnnotationsFiltered = annotations.filter(annotation => selectedAnnotations.includes(annotation.id)).filter(annotation => annotation.area <= 171000);

		

		const selectedAnnoIds = selectedAnnotationsFiltered.map((annotation) => annotation.id);
		const params = this.getAdvancedIHCParams();

		runIHCAnalysis(selectedAnnoIds, params, notAllowedAnnotations_size.length <= 0).finally(() => this.fetchIHCStatus(true));
	}

	draw = () => {
		this.source = new VectorSource({
			features: this.state.drawedAnnotations.map(getIHCResultFeatures).flat(),
			wrapX: false
		});
		let layer = this.props.slidemap.getLayers().getArray().find(layer => layer.get('id') === "ihc-result");
		layer.setSource(this.source);
	}

	onEyeCheckbox = (annotation, checked) => {
		if (checked) {
			this.setState(prevState => ({
				drawedAnnotations: [...prevState.drawedAnnotations.filter(annotation_ => annotation_.id !== annotation.id),
					annotation]
			}), () => this.draw());
		} else {
			this.setState(prevState => ({
				drawedAnnotations: prevState.drawedAnnotations.filter(annotation_ => annotation_.id !== annotation.id)
			}), () => this.draw());
		}
	}

	setOperation = (event, operation) => {
		if (operation !== this.state.operation && notNull(operation)) {
			const operation_message = operation === OPERATIONS.ADD_NEGATIVE || OPERATIONS.ADD_POSITIVE ? operation?.replace("_", " ") : operation
			notifyInfo('IHCNotif', `Select on IHC annotation to ${operation_message}. Once completed, click on save button to save your changes.`);
		}
		this.setState({
			operation: operation === this.state.operation ? null : operation,
		});
	}

	getIHCAnnotationAction = (annotation) => annotation.ihc_analysis.status === 'running' ?
		<CircularProgress color={"secondary"} size={20} sx={{marginX: 1}}/> : annotation.result ?
			getEyeCheckbox(undefined, false,
				e => this.onEyeCheckbox(annotation, e.target.checked), <VisibilityOff/>) :
			null

	getTopComponent = () =>
		<Stack aria-disabled={true} direction={"column"} spacing={1}>
			<Stack direction={"row"} justifyContent={"space-between"}>
				<Button variant={"contained"} color={"secondary"} onClick={this.prepare}
				        disabled={this.props.slide.full_stitch_status !== 0}>
					{prepareStatus[this.props.slide.full_stitch_status]}
				</Button>
				<IconButton onClick={() => this.refresh(true)} color={"secondary"}><RefreshIcon/></IconButton>
			</Stack>
			<Stack direction={"row"} justifyContent={"space-between"}>
				<ToggleButtonGroup value={this.state.operation} exclusive onChange={this.setOperation}>
					<ToggleButton sx={{color: '#94b4ff'}} value={OPERATIONS.ADD_POSITIVE}>
						<Tooltip title={"Add Positive"} placement={"top-start"}>
							<AddCircleTwoTone/>
						</Tooltip>
					</ToggleButton>
					<ToggleButton sx={{color: '#fa8e8e'}} value={OPERATIONS.ADD_NEGATIVE}>
						<Tooltip title={"Add Negative"} placement={"top-start"}>
							<RemoveCircleTwoTone/>
						</Tooltip>
					</ToggleButton>
					<ToggleButton sx={{color: '#ffe294'}} value={OPERATIONS.EDIT}>
						<Tooltip title={"Alter"} placement={"top-start"}>
							<EditTwoTone/>
						</Tooltip>
					</ToggleButton>
					<ToggleButton sx={{color: '#ffe294'}} value={OPERATIONS.DELETE}>
						<Tooltip title={"Delete"} placement={"top-start"}>
							<DeleteTwoTone/>
						</Tooltip>
					</ToggleButton>
				</ToggleButtonGroup>
				<ToggleButton sx={{color: '#93edab'}} value={undefined} onClick={this.save}>
					<Tooltip title={"Save"} placement={"top-start"}>
						<SaveTwoTone/>
					</Tooltip>
				</ToggleButton>
			</Stack>
		</Stack>


	render() {

		if (this.props.loadingState.loading) {
			return <Loader/>
		}

		if (!(this.props.annotationState || {}).annotations) return <LoadingText/>;

		let annotations = this.props.annotationState.annotations.filter(
			annotation => annotation.anno_drawer === this.drawer);

		if (this.state.operation && (this.props.ihcState || {}).selectedIHCResult) {
			switch (this.state.operation) {
				case OPERATIONS.EDIT:
					this.edit(this.props.ihcState.selectedIHCResult);
					break;
				case OPERATIONS.DELETE:
					this.delete(this.props.ihcState.selectedIHCResult);
					break;
				default:
					break;
			}
			clearSelectFeatures(this.props.slidemap);
			this.props.ihcState.selectedIHCResult = null;
		}
		annotations.forEach(annotation => {
			annotation.actionComponent = this.getIHCAnnotationAction(annotation);
			annotation.resultComponent = getIHCResultComponent(annotation.result);
		});

		let annotationsComponent = <AnnotationsExpandableList annotations={annotations} slideId={this.props.slide.id}
		                                                      colors={AnnotationsConstants.ANNO_COLORS}
															  showColorLabels={true}
															  deselectPostAction={false}
															  showMergeAnnotations={false}
		                                                      onAnnotationClick={annotation =>
																  locateAnnotationOnMap(this.props.slidemap, annotation, false)}
		                                                      actionOnSelected={annotations => this.setState({advancedIHCPanelAnnotationId: annotations})}
		                                                      actionTooltip={"Run IHC Analysis"}/>;
		return <Stack direction={"column"} spacing={1} ref={this.ref}>
			{!isCloud() && this.getTopComponent()}
			{annotationsComponent}
			{this.advancedIHCComponent(annotations)}
		</Stack>
	}
}

const mapStateToProps = (state) => {
	let loadingState = state.slideLoadingReducer;
	let {activeMapId} = state.gammaStateReducer;
	let {slide, slidemap, annotationState, ihcState} = state.mapsStateReducer[activeMapId] ?? {};
	return {activeMapId, slide, slidemap, annotationState, ihcState, loadingState};
};

export default connect(mapStateToProps)(IHCApp);
